import { commonAction } from '../actions/common'
import { commonMutation } from '../mutations/common'
export const common = {
  state: {
    'system/cararea': {
      data: []
    },
    'system/carcity': {
      data: []
    },
    'system/carbrand': {
      data: []
    },
    'system/carseries': {
      data: []
    },
    'system/carmodels': {
      data: []
    },
		'system/companies': {
      data: []
    },
		'system/verifycompany': {
      data: {}
    },
    'system/wxjsconfig': {
      data: {}
    },
    'system/address': {
      data: {}
    },
    'system/feeinfo': {
      data: {
        'value_price': '',
        'person_price': '',
        'sesame_price': '',
        'td_price': '',
        'free_times': ''
      }
    },
		'system/pricelist': {
			data: {
				original_policy_price: '0.99',
				original_insurance_price: '0.99',
				original_illegal_price: '0.99',	
        policy_price: '0.01',	
        insurance_price: '0.01',	
        illegal_price: '0.01'
			}
		},
		'system/orderid': {
			data: {}
    },
    'common/risktype': {
      data: {}
    },
    'common/payforarr': {
      data: {}
    },
  },
  mutations: commonMutation,
  actions: commonAction,
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js